import {
  useProStudioCtxSelector,
  useProStudioStateMatchesOneOf,
} from '../xstate/app.xstate';

export const useLoadingState = () => {
  const { ready } = useProStudioCtxSelector((ctx) => ({
    ready:
      (ctx.userProjects && ctx.project?.id) ||
      (ctx.userProjects && !ctx.project?.id),
  }));

  const loading = !useProStudioStateMatchesOneOf([
    'studio_idle',
    'accessDenied',
    'error',
    'checkingUserInfo.projectFlow.projectDataLoaded.idle',
    'checkingUserInfo.projectFlow.projectDataLoaded.botFlow.deletingScriptFlow',
    'checkingUserInfo.projectFlow.projectDataLoaded.botFlow.loadingScriptFlow',
    'checkingUserInfo.projectFlow.projectDataLoaded.botFlow.botFlowError',
    'checkingUserInfo.projectFlow.projectDataLoaded.botFlow.updatingSolutionFlow',
    'checkingUserInfo.projectFlow.projectDataLoaded.botFlow.downloadingVersionFileFlow',
  ]);

  return loading || !ready;
};
